import { useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { ProxyLoginContext } from '../contexts/ProxyLoginContext';
import { isOperatorStaff } from '../utils/permission';

type UseDetailModeReturn = {
  /** 運営スタッフ向けの内部情報（コスト・削除済み・検証UI等）を表示してよいか */
  isDetailView: boolean;
  /** 詳細モードのトグルを表示してよいか（運営スタッフのみ） */
  canToggleDetailMode: boolean;
  /** 詳細モードの ON/OFF を切り替える */
  toggleDetailMode: () => void;
};

/**
 * 運営スタッフ向けの詳細表示（コスト・削除済みパターン・検証UI 等）の可否を判定するフック（#3069）。
 *
 * 従来は「非代理なら常に詳細表示」という判定が各画面に散在しており、運営企業アカウントで
 * 詳細表示を OFF にできなかった。判定をここへ集約し、代理・通常のどちらでも
 * ProxyLoginContext の isDetailMode を尊重する。
 *
 * 詳細表示は運営スタッフ限定の情報を含むため、必ず権限判定と併せて評価する。
 */
export const useDetailMode = (): UseDetailModeReturn => {
  const { user } = useContext(AuthContext);
  const { isDetailMode, toggleDetailMode } = useContext(ProxyLoginContext);

  const canToggleDetailMode = isOperatorStaff(user?.role);

  return {
    isDetailView: canToggleDetailMode && isDetailMode,
    canToggleDetailMode,
    toggleDetailMode,
  };
};
